import React from 'react';
import { SvgProps } from '../../types/index.d';

interface Props {
  isInCircle?: boolean;
  circleColor?: string;
}

export function ClockIcon({
  fillColor = '#53585E',
  className,
  isInCircle = false,
  circleColor = 'black',
  ariaHidden = false,
}: SvgProps & Props) {
  return (
    <svg
      viewBox={isInCircle ? '0 0 24 24' : '6 6 12 12'}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden={ariaHidden}
    >
      <g fill="none" fillRule="evenodd">
        <g>
          {isInCircle && (
            <React.Fragment>
              <rect fill={circleColor} x="8" y="8" width="8" height="8" />
              <path
                d="M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M11.3026634,8.90556901 L11.3026634,12.3050847 C11.3026634,12.4358354 11.3753027,12.566586 11.4769976,12.6392252 L13.409201,14.0920097 C13.4818402,14.1501211 13.5690073,14.1791768 13.6561743,14.1791768 C13.7869249,14.1791768 13.9031477,14.1210654 13.9903148,14.0048426 C14.1210654,13.8159806 14.0920097,13.5544794 13.9031477,13.409201 L12.1452784,12.0871671 L12.1452784,8.90556901 C12.1452784,8.67312349 11.9564165,8.4842615 11.7239709,8.4842615 C11.4915254,8.4842615 11.3026634,8.67312349 11.3026634,8.90556901 Z"
                fill={circleColor}
              />
            </React.Fragment>
          )}
          <path
            d="M12,18 C8.68765133,18 6,15.3123487 6,12 C6,8.68765133 8.68765133,6 12,6 C15.3123487,6 18,8.68765133 18,12 C18,15.3123487 15.3123487,18 12,18 Z M11.3026634,8.90556901 L11.3026634,12.3050847 C11.3026634,12.4358354 11.3753027,12.566586 11.4769976,12.6392252 L13.409201,14.0920097 C13.4818402,14.1501211 13.5690073,14.1791768 13.6561743,14.1791768 C13.7869249,14.1791768 13.9031477,14.1210654 13.9903148,14.0048426 C14.1210654,13.8159806 14.0920097,13.5544794 13.9031477,13.409201 L12.1452784,12.0871671 L12.1452784,8.90556901 C12.1452784,8.67312349 11.9564165,8.4842615 11.7239709,8.4842615 C11.4915254,8.4842615 11.3026634,8.67312349 11.3026634,8.90556901 Z"
            id="Combined-Shape"
            fill={fillColor}
            fillRule="nonzero"
          />
        </g>
      </g>
    </svg>
  );
}
